<template>
    <div id="bottom_menu" style="height: 55px;">

        <div class="bottom_menu">
            <div class="inner">
                <ul class="maxW375 centered">

                    <!-- add active class when current page match menu item -->
                    <li class="menuItem">
                        <router-link class="primaryLinkColor" to="/" :class="{
                            active : activePath == '/',
                            colorFFA724 : activePath == '/',
                            defaultColor : activePath != '/'}"
                        >
                            <i class="icon homePageIcon"></i><br/>首页
                        </router-link>
                    </li>

                    <li class="menuItem">
                        <router-link class="primaryLinkColor" to="/vip" :class="{
                            active : activePath == '/vip',
                            colorFFA724 : activePath == '/auth/shixunVip',
                            defaultColor : activePath != '/auth/shixunVip'}"
                        >
                            <i class="icon vipIcon"></i><br/>会员
                        </router-link>
                    </li>

                    <!-- 发现页 -->
                    <!-- start -->
                    <li class="menuItem">
                        <router-link class="primaryLinkColor" to="/discover" :class="{
                            active : activePath == '/discover',
                            colorFFA724 : activePath == '/discover',
                            defaultColor : activePath != '/discover'}"
                        >
                            <i class="icon discoverPageIcon"></i><br/>发现页
                        </router-link>
                    </li>
                    <!-- end -->

                    <li class="menuItem">
                        <router-link class="primaryLinkColor" to="/me/meComp/learnListMore" :class="{
                            active : activePath == '/me/meComp/learnListMore',
                            colorFFA724 : activePath == '/me/meComp/learnListMore',
                            defaultColor : activePath != '/me/meComp/learnListMore'}"
                        >
                            <i class="icon learnIcon"></i><br/>学习
                        </router-link>
                    </li>

                    <!-- 个人中心 -->
                    <li class="menuItem">
                         <router-link class="primaryLinkColor" to="/me" :class="{
                            active : activePath == '/me',
                            colorFFA724 : activePath == '/me',
                            defaultColor : activePath != '/me'}"
                        >
                            <i class="icon mePageIcon"></i><br/>我的
                        </router-link>
                    </li>
                </ul>

            </div><!-- end .inner -->

        </div><!-- end .bottom_menu -->

    </div>

</template>

<script>

import externalApp from '@data/externalApp';

export default {
    name: "bottomMenu",
    props : {
        activePath : {
            type : String,
            default : '/'
        }
    },
    data () {
        return {
            externalApp : externalApp
        }
    },
    methods : {
        setActivePath : function (path) {
            this.activePath = path;
        }
    }
}
</script>

<style lang="scss" scoped>
/**
 * style for bottom menu
 * @author: zhiwen, zhengpei
 */

.defaultColor{
    color: #B2B2B2;
}

.bottom_menu {
    position: relative;
    z-index: 5;

    margin: 0 auto;
    font-size: 12px;

    .menuItem {
        position: relative;

        .icon {
            width: 24px;
            height: 24px;
        }

        .homePageIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEgElEQVRoge1ZO2hcRxSdYgsVLlSocJHCEBUqXKRIYYhBKgxxYbAhggiiYiEqBDHEEIMNciFQQOoksMEBFS+QQgEHRveceU+FiikUUKHChQoVKrZw4UKFChUqtkiKnfc8O5p9n42ySmAvDIi3M3fOuffOmY+UGtvYxja2/71Za1si8hXJH0i+BrBH0gI4Imnd378BWEnT9LHWevKmMStrbQvANyR3ROQCwF9NGsn3ANZJzowUuNZ60hizIiIfmoIuaXsAHv+rwJMkmRCRVQDnNaL7EUAHwAHJY/d3nazsi8j0tYMH8Kgi4ociskryfll9G2PuisgyyR0AZwN8XQJ4cS3AXdTfDpjoXETeDFvD1toWyXm3wGP+E2tta2jwJKcAHEQcdwH8HIs0yaksyz7PsmzWGPN1lmWzdQiSnANwEispa+2txuDTNL0dcwjg0AeUJMmEU6K3A/rn7SBJkomyOZ2vjchYNsqEtfZWBExXRJ4G/VoAjuoqjYgs5mNFZBrAJgCSXPOzSXLJZdkfv14XfMtJWh94kvNhXxH5MgL0AsApAMueXXoElpVSKsuyzyILuBOQmI+U01wlASeTIaBHsb6uzIq+xpgHfqod0CKSWus7bo4t9+1Pkk+8LK4EWF6FJEvXg4uon7pumqYPywi73TSP8MKgYJDcz78DsO7bvPOxlKtO6D+sBhFZHQgGwGHtzp8IvPQXeP7dLciPHoGiBEXkjft+BOD7fL2JyKvQv9b6jquCQrqj+4xLpZ+uoyrwShVl1PVIL7pgPPN8nfql5cacBvOdkJyKzRGWdTSwJPcDh/fqEHBgNzznFyS/g3fcCNVLqd55CsAGyXckX5bt3q6vf3w565NVJ2k++L264JUqyqUTUaQr0R/WEOwPJJ/4BJaDH69IZpWRnImURT3pq2FhkElqf/IdX3mG2rpVcfT4w/P17DrAe/4LkRGRiyKzuaw1WbxlJiLTueZfpwWK9ym7AQF73RM3ADhVln0A96JqdJMESM6R1P6V1N07trXWX/h93THHVyN9YwQcmO0ByuW3vnUUbLadGyHgXjDe1QB/hYQ7the/aa0nR04AwPOI3B6TfO2eZEI5Pk/T9LZSSonIU/83Y8zdkRJwUnvpgwjPQO6q+WtAcE0ppYwxC/733d3dByMlYIz5KYjuL7F+7lJ15hE4VkoprfVcML496gz4d+yLsjMQgCSsd3c69QmsjJSAL4MkD8r6hvXunmz6CIjIamMC7gUhQe8c33HjX9Q5ggTR26yY535AYMnd8oYngN5FfJDcdcqeUKLRK7Eo2CAIjQiQXCsBn7eTQcfnpgRCsCS3hybgJg+fOk7Re/vsk0WtdXtAAGauKEiFuTfWvD8rS4jk+yzLZsNmjNkMBm7lk0QeAw5jPkj+OASBEx8byW+rMlCrha9sANjURx0CNbA9b0yA5IfIROtNCRhjFmKggwzsVPhpK5JbDSf/PTJRuENWtW6dSw+AdpmP4n8JDkC7qonIw0EqQ3JGRBZr+FhscmND7yLzj3yMbWxj+w/b32vf7KH8pQbpAAAAAElFTkSuQmCC');
        }

        .active .homePageIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEs0lEQVRoge3YP2ibRxjH8XfwkMGDhwweMrz4fq8QuIOHFDIYKtpACw3UQyEdDDHF0EIzBBraQDsYGuiQQgspNOBBQ2qd9Dq2bMt/kjjNm8ZxnMR2nNYUDx0yeNCQQYMoCbjw7fAqdmS9ki05jl3QA7eens89d897J8dpRjOa0YxmHKbAxl0m9A7j5gzj5gyTpTGj95mWOej8KgLfiIz5koyZZVhFrglGBVnBuGBCkBNMCaYF11XkhmaY9b7hutHBJB0kWvDNaaw3hxWkBRnBsNgFAG4IZgW3BLe1yF19RJBo2f/EfSOuGpGJncSKcJg8aQ2SUS++10XWbXMcxyHpHmHciFyshykNMqVCJOA3QSC4ozWC2Mn9STzptmHNL1htkOroxnqXsCaP9fperhwpN86IOc2ovmZEA4xogDHzGVNel+M4DlNuO9Na3ATcrADAXcE9DRJ0tr6+5FOxbqzWt1Y87pJWDuslHcdxsPqCjNZrbqEpZR3HcZjxvtsRMCeY1yqP3Pa9J29NH1YbW8mXAFYB1kty1ah0Bor4ypIx57kW62FYCbJKMBY7yYRWmVS+LsA9wX2tc38Ph5y0OVue+KsVMLNYL4lVAitIukeqzpPz5pj0npYAtgww/y4EndUAsKA1lmJHG1h5fVy58qUx5HWR1mWsFhnyurCClPkgcp5xIyYEk2bOcRyHaW9lE5DPAcCLPMyfqAaAh5qpL/lwWxSjV1+QUi8p9YYHOnYUq2ekwz1eMdeYuVQCXCQXO7rZhW6/TVmsfVULAA/N2d0lHyRaSGulavLhfh8Mu5Kek9IFrH4mLbBKlM2VddsYUyE8xB3Hyam/rI0WlsLk//0HHrxXG/BIBf7QsZ0BQ9X2fdko4ne2kjJXSpVKlA7xGv5W+yOrAcYEOQWO4zhMaaEMcKsTVj6Fe921zsBLACyHXa968km3jbQKuwBAShfw3XZSKoQfMvMDGYHvDYfJx12yKoaAWDc5JSq+xDt3oXLAkjZYrtGVqnedyPEc36h02CGtDTIqMCwYNpZRrZIVZL2fCBIt5LT6GgCwrB+rA6zW6gCA1VqpCuci70KjGisl/33kXagxQIEgomWTcuN1Jr+F+FXHyJgefJPfBIyYKwSJFsbUX/UyVy9gUbAsWDE9Eavf8XmDAMI26p0i67YxrH58r4sg0bJ5iOsB/L4bgK5GdB8N7AEQXqd95bgWizPifcioVsiKfQE81rP9AURd5qIAM3sGwEp4w/3/Ap5s+zK/dsBI3YACd7TAXQXMaZF5Pa8N0OXDAljnlvlk+3OSoLOV++Y8CypGA7y5wwBYI6j9aGHevMUDFSMqkD9owAY3tx3EaohHXl8EgLKqvXmAZ3eT/GZ+i/q7ArASdw8OcD36AVQV8NBcrAA87jh+cICo+0ztCiQqK/DK++MNA/LVU60C+Kuz9RABwgd+3Ygl5csAT9TbKOAZ1vuW8CV2gpTOYbf9L1S7AosNAhbKK+D1NQDwnuJX9m58t52M1ncJCBoEBOUV8E7VDxiq/t8lafXvK2DZS+7tDKRUqPkDfmdrTcDkQQPstvtHJMJ7ujOgvo/Y5txLGiwD/BmLNzJPM5rRjGY0oyz+A1D3I6zt3hHuAAAAAElFTkSuQmCC');
        }

        .vipIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEMElEQVRoQ+2YWehVVRTGfxZGllCZDVoUEWFU2GSoVJJNFpVNlFpow0uRZEGWUDQYQmg9NFEqNFGZNNOsEZRkhEovUqY+FBQV5YNFZApG/GhduB33vWefe07/+MPdT5d79l7r+9Za+1vrnCEM8jVkkOOnT+D/zmA/A/0M1IxAv4RqBrD28V4ycAywFBgDjKyN4B8DvwAbgbuBj6vYrEpgHLC2ioMe9h4HfJl7rgqBA4Cfw/C7wGLgnVxHJftOBe4Apsa+fYDfcmxXIfAjcHCkeAqwI8dBhT17AO8DZwKbokRLj+cS+BQwSqb2fOC7Usu9bTg0SFhGLwAzy8zkEHgOmBXlcwGwrsxozecnAe8BBwH3A/d2s1dG4B5gPvBX1Ke1PxDrPEBfuwFzgMc6Oe1G4OpIo2evB54ZCORtPsy62XfNAJan/HcioL5b92q96vDgAINvuZsbvu0RpwFbijg6EZgOvBSKMzkB/kLAnnBfA8TE8HT4W5mw9zkwHrgOeDaXwG3AQ8ATwOyEUcvp2kir6e11KZ0G6jLgTeDSLr7mAYtyCRjht6PFTwK+LhxU5l6NEsuSuwSwvQP8RcB6YBqwobDvaGA1MCJIvpFLwH2m8xzAFBqZnwqHTwReAY6MC+5Fz112WiNvT/kCsGQ3Fw4ro2ZlAvAhcG6VS+ze4wEZHwF8AFyc6L6nRCYOiwHvhgwGCoTgzwbWBPhvCucsLcFLUGKXR5Z2MV/WB04PEvt3qfeJQWJ0lzvTcjwKWAacAXwWZfN9gvSLwFXR8QXfcYAsI6Btu6+ZGAo8CdyUcOg98U448D0C3JrYY5YE70jySUS+WJYeezyE40/AmWtVt6zmEPC8SqNz1wPAnQmjDmGS2C8U7Pa2Pd4To6ocfhTgd9F0YAFwV5wTfEpW/+U6l4CHbowM+DspaXHRXgOGtxG1GUreGWdFgN+aCEBLun3kfXsr4z5V/rBlV14Yhr2wvpkVlyVnJvaMYewSYGy8O5jJ3xNnVLCn4n/l9OUc8O6pkoGWzfY0XxFgi/6MoJnYPR6oKErl9gQwm5h7XTbH1vyTxaEXAhp+FLgZ+COmVOu6uFQP99mIjPzOxB7HFN/q9ooSXZKFum1TrwQ04VxyDfADYDe1IVVZJwT4Q0K1VK/Kqw4Bnb0eXdo3NcePbzMRHB7gHUlKX1q62axLYFjMTGdFqXiBfy0h4RjhnGWT7NRXMuPQ2yUuGndmEZBjhfVsOXVbyqN7VCpFoNaqm4GW86OChJr/fLxDp4C13q/txI4TtVdTBARycpBw3lF9bimgezj++wo4tjbyMNAkAU0qi5aTs74fA/y9Dbgyvi74CfHApsBrp2kC2rSJKbH7JoA27q9xgwFajfd7jqO2DcxvSRJrfP1XBBoH2slgn8CAhbqDo34G+hmoGYF+CdUMYO3jgz4DfwO+4LcxoPpkcwAAAABJRU5ErkJggg==');
        }

        .active .vipIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEsElEQVRoQ+2Ya2gcVRTH/3dmd2cnbZM0b/WDL6rVptnZtFXjA3yg/aDuJBbR4vuDUASrkGIKosUigrYgVrAofqhYVEIxmawIKkKr/WCpNbMtaU2DjxI1mlRb02azyezMkTtjtKSZx74SCjtf55z//f/OOffe2WW4wB92gftHGWChO1juQLkDBVagPEIFFrDg9Jw7MNUbv9Zi9A6AqwHUFewAAAFjDBiEhRfkDn1vLpo5AUxo8dUC6GAuC+QaKzBqlhKpgaB5gQHOdMfrQxKNBhUuJC59RqqqffjAeBCNwABpLTbCwJqCiBYh5ris6nxEfZ9AAGlN2c+Am3zVihuwW1b1R/wkfQEmNeU9AI/6CZXkPaOtciK1xUvbE2CyN/4iGL1UEnMBRYnRxopE6k23cFeASU15CMDugOuUNEwAWy+p/R/NtcicAOPJVXVhy9z/71lfUnMBxQcNQby58t5DJ2fHzwmQ1uIPMtCHbuJC/RoIlVci+8OcRQnoaSaMIdy8EebIPlh/6u65Fp6QO/RdQQE6GWi7m1q4+RmIF98O8/evYRx2DfMHEUIIr9wEsbEN1ugBTOuvuOYIQJek6q8FAsj0xe4hYknXjbP4UkRiXWCLLoE5shfGkdf9zc6OECVEWjZBqL8OdPYEplPbQBPD7gBE90ntqZ5AADxoUlM+B3Cn6xgtuQJhDlHRBPPXL2EM7AgOEVrkmK9rhTX+I4zD20Dp37zyv5BV/a7Am5gHTifjMdMiTny5K0TVMgciWg/zl89gHH3LF4JFKu2xEWpjsP4ecsxP/uGVNySQuE5qP3QkJwC7C5+03gLT4hC1rhDVyx0IqQbm8Kcwjr3taoZJSx3zNc2wTn/vmM+cd7Cck8+GRUbrIgnd9QPS9ybOaMrdBHCIsCvE0hUORKQK5okkjMF3zwvlXQq3dEKovgbWqQHH/NQpj8pTBhDWymr/V17t8QXgyVN98fUW0QdeQkJNiwMRXozszz3IHv//xGNyk2O+6ipYf6VgpLaDDO+PTcZobTSR4vvQ8wkEwBUmtNgGAWynJ0RtHBGlCxBlZH/ag+zQ+/ZJFV7Zad8b1snvMM2P3eyEjymmRtX+Pj/z/H1gAB6c1pTnGPCqJ0TdakSUzYAQti86seEGsCWXwRo76Jg3M56+BEYPSIlUdxDzOQPYG7tXeRkMz3tCNFyPSGwzwAQ7zBz9xrnwLMPP1+OyqvOv38BPTh2YUU33xnYwxp72WkVsvBGh5U/COn3MMU+W99gQbYi2p9yPMJfsvADsTmgK36WPBS6VRyADno2q+hv5aOUNwBfLaMrHBHTks/B/OURb5XbvHy1e+gUBUHebnImmkyB2R54QO2VVfyrPXDutIAAucFZrbhQR4h9+a3IxQoQ9Fe36/bnkzBVbMIA9SkllGVngEIH+SQCwT1b1Wws1X5QOzJiY7mldZQoWh7jIx9hRWdVXFMN8UQGckyl2G2MsSYRFLgbHZFVvKJb5ogNwwak+RSXCLgKqZxuVVb0oI3uubtEF7Y3doyghEVuI0MYvYgK+rVB1tZiVn9EqCUApjLpplgHms9oluwcWEqI8QgtZ/ZLcA/MNVB6h+a747PX+AU1Fb0Ap/SAFAAAAAElFTkSuQmCC');
        }

        .discoverPageIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAD5ElEQVRoge1Zr29bSRBeEBBgEHAgrAYBBZWusKBSLN0/UBBQqaTgQKVESqSrdCABkUpOOnCwIMCgIJEjeTLft88FAQsOFhwoCAgwDDgQYBBg4IKso816X/1+ObmePNKiN2/2m935vcYsaUlLWtL/hlR1g+Suqp6SdACGqjpS1RGAIUnnv+2q6sZj4zXGGOOca1lr9wFcApiUXJfW2n3nXOsxgK+Q3AZwVQF4vK5IbjvnVh4EvIi0AXxtAHi8vopIe6Hg+/3+y7xTJ3lD8lxVd0SkIyJt51zLOdcSkbaIdFR1h+Q5yZu82+j3+y8XAp7kFoBxYtNrVT0UkbWiskRkTVUPAYwS8sYktxoF708+Bf4ky7L1qnKzLFsHcJJSorGb8DY/YzaqetDIBsYYVT1ImVNtn3DOrSQctvkrNncmOuPYtaKTqu4s8uQT+83chKq+qyTMOddKmM5Jw5hnKOETV5WSnc+w96JNHYfNozh6ece+F52stfulBSMqD1T1sA5Qkj+R/IXkLoAjAF98nTQ+Ozv7NeT1ITY8vItSm6nqRpykysR5a+0zkm+stX8C+JyX/AL5DP8XkbU42ZUqAAG8jzY4L6F8fHpF1ttYDsnziGevsAIkTyPtdwqC3wCQVyaMAHwheQTgIjSPVKiMIyDJ08IKAHDhzyLSKaj4cQhMVQ9JviL5dMrjnfQmAPYqJUtEOtEBuDIKDCMF2gX+eRFt+CKH7ygA/0+ePF8BhPKGhRXw0eHu5263u1pAgb/n5QtvYuNAgU6ePJ+HQjMeFVYgjgDzFFDV12HEyosYAD4FfN81iVgBAMUVKGNC3W53NcoZf6T4ROR5ERML+KubUGQOE5K5pW0Ucv8N84VXbpPkh0hJmYehlhMXDaMisgbgOuQj+bO19jcAn2Nf8mtsrX02D0PdMLoX/ZxMZAD+isBdJwDfA1+0JKmVyOJSAsBMKRFHlO+sS5IfSW4VLUf8zVYvJYyZX8wB+D0H8JVPaG+rdlS1izljjCF5ECkwCstpkk9xWx6McFuwvReR51UAh5Rl2XrsOyTLN1GphobkccjT7XZXmx5IReXIBFUbGmN+8JbSmLsR4swU7qGaepL1mnpj8scqAMq3eTkEIG5fJ2hirDIlksnBFsnjXq9XuU/u9XrrCZuf4HZ00+yIMW+06N8AKo0W8zL1Ikx0qkTucBfAjR/cbg8Gg80sy55Mh7tZlj0ZDAabJLd9hs0d7jZ+8jGJSDvl2HUXycWP16fknFvxIbaRBw5VffdgDxyRIi2fsas8MV2QPHiUJ6YU+eJuz5fiDrdN0bTUGAJw/tvef+aRb0lL+sHpG9gRAn6B/QWxAAAAAElFTkSuQmCC');
        }

        .active .discoverPageIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADzUlEQVRoge2ZS2hUVxjHj1SFglLpWnAy57uJOAtfFHRTAgVFJV0FBAU3tgvBVo0aRHHRImThTugiqLgQ7jlzSLT1FVC0NLQSazTR+MRGI2q06hjHMEzGmfh3cWVu7szNzD137twBmQ++xQyH7/x+53VfjNWjHvWox2cTMCkGSW2QpCDoGgQ9h6DMp3wOSf0QpCBoB8zIwlrzMsYYw7HIPJh8JwQNQRA0cxDS2IY/muaGD965fBbitBeCxn2AF+ZbCL4Lin0RDryMNkLQYADgBcn/hVgYqTI8XwNByeDhP6U0Eogb31YHXvD1EPS+avB2pqGi64KFV9QKQTmXaa+WRAZxWh0MvGxYDEETIYy8M01KQi1oqAy+c/ksSLodOrydlwE2o4LRp7Yawlsp+SZ/8Cr6FSSN1VxA0FOo2Gwfo8/3hQLYtdTDfmj4wYcAPQwU9MQ3wKVNwLUDwH9xIHETyKaAySxwZW/ZvaALv6Ii2HNrgMs7gbtHgNG/gPRLlIxnl8rX7G5Y4F1A8P3OAhrn/dCh0rBu0dfuUquoz80aAtTjS+D0d0Buwh0ymwISQ8CwApLD9v/JYUA2la8t6bCGgPHIl8DjM06woUNA7xbg7Cq7zcmVTsneLdPUK+yT93oXMCmtve7PtzpH/Hyre7thZbd5c6dEzSKBEZ0lNKk9Ay/7bbDHZ6ZfYpNZu93FjToCKR2BjJbAP9tsqNyEBerW7tHvdrv/+8oMSlGfGe8C0kh4FlAx4N2IDXan071dT4u3JTZdnya91pmBW54FBjpsqIk3QNcyp9zFjcCt34DxKZJPLujtL4vhhoYA7/ZUtGsZkEnaYP2/WCM90GFdwLIpFMWHHHBurQ8BiusI7PI0A/eOOeGmyrjFh5x1tHoBNgt+S9ruXUAZS8p2UHiiTBfvRoAHJvD3Vufy0k1FizwLWLNA90sWHDzoDpx+ZR2jfe3AqWb/wM7Rv6kFzxhjkMbukkXPrrLWeDYFjPZa676nJRjg4g38s77A0aa5EFT6OFUxb/cxleULqPlfagswxhgE7agyXPmM8x99wTPGGP5sngmzpg/1Vyt6qGeMMcjGEF6ruB7T41CcKoLPSyi+HoK7vNiqWr5HPLo2EHhbIroBgrIhwKcRp5ZA4fMSgr5HyVfqvPgKKviULAufgKDmqsDnJawvMcFvbJOuQEQiVYXPS6jYbAj+KyRPBQA+BkltoX3gcIrM/xqS9kDQXR/w1yGNn6Bic0IHdwscb1wM02iH4N2QNABBL5D/yMdHIfhVCJKQfCtktLHWvPWox+cQHwH4/FgLEX557gAAAABJRU5ErkJggg==');
        }

        .learnIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACBElEQVRoQ+2ZTSsGURTHf88XsLNDedkQG9kohZVSbMRCkqysLWSHYmFlaSULSrHzAbChKJK8LGyUJC9JWVnR0R1u0wxzx8zcnjp3OXPe/nP+594755Qo81Uq8/hRAL4zGJeBaqDeMbhr4C6hTgNQlVA2EDsHnsM6UQC2gT5H44H4EyD668BeyMYY0AsMprQtanPArK0fBiAvZyKcJ/FZB9RYgrazVUAABOsBuEpiNCTTBQwBW8HzMIBbk9q0xd0CDAPTxoGAaDJf/R1YAjaAsxTBBx9XghcQXysc6EfMc1d/QpNNS+kCGAVOXA1Z8jY7uvMGIPaXgQnjqAPY/0fwolo4gBFgzQRdGbWDOAIqHIAU3G5GlPSSAQUQophSyLHmUAophVw5E3Fv0W3U51Wi7Iu407qWp73d2qws/BxQAL63Uc2AZuCfB5lSSCmkFPrpzulJ7KOtoruQ7kK6C3nYhQ6AduC7++uYhUfg0ujEFbH8qaVZoiezC2nRT8Z1p6WXL63wtEumMjIfuAeiAIwDK2mNG71a4CYOgDwXpANAs6OjVqACeAEWgUPrl1La61NAv7F5Crw62j8yM4djWy+LEzKw1wbMAz1/BCbgFoA3RwCR4lkCCBwIT2Ve1mjGSzL4k7qQKaYMAHeyCPw3CmVpP3dbeWQg96DzqoFCA1cKefncEU4/AfljsjFVl6izAAAAAElFTkSuQmCC');
        }

        .active .learnIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACSElEQVRoQ+2Zz2sTURDHP/O2qLVI8bAhORQ8ePBQYioiEhF78qRILj1692/yIPgHaOO1h6YXFamQthS9WHozdKVWYhKizRvZpMTF/kh2kzQG3oNleeybefOd+b6Zx44w4UMm3H5OBVB5mZ2ZvWJ86+F7gq+HpNTgh4DFEsgUey0lMC2CH1UbpJ9u1uI4Y1j6uwBqxZsLAvc4egSZi2MQsItQosUaUJoulHej8o3XuWvAIh4PUBaBcB5nfAFdUXTNM1q++Hjrc9uZjeXccxHuKGTjaOtjbQdQOJIZ3GMLfS9QlkYxp30Y898ucQCShiYMP8iOVa14ol+tkYqoVtqMU8kYJG3RjCoZEUkjmkHJABeie55XBKrAusB6y/L2F5SuFsoHccE33uRWj85TV3TkAFrwsN78/S61tP0zrsH/rh8LgOkn5aEVSwcgCQVcBCJecxRyFEriAUehAb3mspCjkKOQuwt1OeAqcZLj4NKoS6NJeBORcRRyFHIUcpXYVeKBToFLoy6NDkQg6IdC0X6ZYD3jyX6zdvhtdml7P7r92K/TzeKtrKJ5FfKo3gB8CRuIyswZfqoD34EDhODcf68jvEC5D1wfMJgnio+8PzAKo8fRoRkZjlMjIEJNlQDavAsw7Elnjgo+lhThuz8eHwMwLP1/AQifQDbF2lWm7MqlR1s7cdzWRyP7zEZ4r73qy/Nz4OUxYQKQvMDtUEZqxYVnYu3Hy4WND72UxPneBdQROta5j6PrpLXVV9l5Y8zdofWvBjUoqfzEA/gD/MHUgCaluh8AAAAASUVORK5CYII=');
        }
    }

    .inner {
        position: fixed;
        z-index: 2;
        width: 100%;
        bottom: 0;
        left: 0;

        background-color: #fff;
        -webkit-box-shadow: 0 1px 7px rgba(0, 0, 0, 0.11);
        -moz-box-shadow: 0 1px 7px rgba(0, 0, 0, 0.11);
        box-shadow: 0 1px 7px rgba(0, 0, 0, 0.11);
    }

    .remindRedPoint {
        position: absolute;
        z-index: 1;
        top: 2px;
        margin-left: -8px;
        width: 10px;
        height: 10px;
        background-color: red;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        text-align: center;
        color: white;
        font-size: 10px;
        font-style: normal;
    }

    .remindRedPoint.showNumber {
        width: 17px;
        height: 17px;
        line-height: 17px;
        margin-left: -9px;
    }

    .flex1 {
        flex: 1;
    }

    ul {

        padding: 0;
        //margin: 0;
        margin: 0 auto;
        list-style: none;
        display: flex;

        .menuItem {
            display: inline-block;
            flex: 1;

            text-align: center;

            a {
                display: inline-block;
                padding: 3px 4px 7px;
                text-decoration: none;
                cursor: pointer;
            }

            .writeLink {
                padding-top: 31px;
            }
        }
    }
}

.vip {
    color: #FF7548;
}

.bounce-enter-active {
    animation: bounce-in .5s;
}

.bounce-leave-active {
    animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(1.5);
    }

    100% {
        transform: scale(1);
    }
}

</style>
